/**
 * The app's brand mark — π glyph on a violet→cyan gradient with a
 * checkmark accent. Mirrors public/favicon.svg byte-for-byte so the
 * tab icon and the in-app logo are the same shape.
 *
 * Inline SVG (rather than <img src="/favicon.svg">) means no extra
 * HTTP request, the logo renders sharp at any size, and we can theme
 * it via CSS later (currentColor, etc.) if we want.
 */
interface Props {
  /** Pixel size (square). Defaults to 64. */
  size?: number;
  className?: string;
}

export default function LogoMark({ size = 64, className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="בגרות מתמטיקה"
    >
      <defs>
        <linearGradient id="logoBg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#7c3aed" />
          <stop offset="55%" stopColor="#8b5cf6" />
          <stop offset="100%" stopColor="#22d3ee" />
        </linearGradient>
        <linearGradient id="logoGloss" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.18" />
          <stop offset="60%" stopColor="#ffffff" stopOpacity="0" />
        </linearGradient>
      </defs>
      <rect width="256" height="256" rx="56" fill="url(#logoBg)" />
      <rect width="256" height="140" rx="56" fill="url(#logoGloss)" />
      <text
        x="128"
        y="184"
        fontFamily="Georgia, 'Times New Roman', Times, serif"
        fontSize="168"
        fontWeight={700}
        fill="#ffffff"
        textAnchor="middle"
      >
        π
      </text>
      <circle cx="202" cy="202" r="10" fill="#ffffff" fillOpacity="0.85" />
      <path
        d="M 196 202 L 200 207 L 209 197"
        stroke="#7c3aed"
        strokeWidth={3.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
